/**
 * @generated SignedSource<<c2ecfa3181c706f43bc294aac99e0dba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultAuthorCardAuthor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "authorBioAuthor" | "authorNameAuthor" | "authorRoleAuthor" | "entityFollowButtonBase" | "followButtonBase">;
  readonly " $fragmentType": "defaultAuthorCardAuthor";
};
export type defaultAuthorCardAuthor$key = {
  readonly " $data"?: defaultAuthorCardAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultAuthorCardAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultAuthorCardAuthor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorBioAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNameAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorRoleAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "followButtonBase"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "d0a919c6beb4fc522e5ceb936c6d423e";

export default node;
